import { SET_PCLN_BOOTSTRAP_DATA } from '../../actions/actionTypes'

const pclnBootstrapData = (state = {}, action) => {
  switch (action.type) {
    case SET_PCLN_BOOTSTRAP_DATA:
      return Object.assign({}, state, action.pclnBootstrapData)
    default:
      return state
  }
}

export { pclnBootstrapData }
